import React from 'react'
import { lifecycle, withHandlers, withState, compose } from 'recompose'

import isMobile from './../../helpers/isMobile'

export default Next => {
  const IsMobileHoc = ({ isMobileFlag, ...props }) => <Next isMobile={isMobileFlag} {...props} />

  return compose(
    withState('isMobileFlag', 'setIsMobile', false),
    withHandlers({
      calcPoint: ({ setIsMobile, isMobileFlag }) => () => {
        let isMob = isMobile()
        if (isMob !== isMobileFlag) setIsMobile(isMob)
      }
    }),
    lifecycle({
      componentDidMount () {
        global.addEventListener('resize', this.props.calcPoint)
        this.props.calcPoint()
      },
      componentWillUnmount () {
        global.removeEventListener('resize', this.props.calcPoint)
        this.props.calcPoint()
      }
    })
  )(IsMobileHoc)
}



// WEBPACK FOOTER //
// ./src/containers/Main/IsMobileHoc.jsx